// Mirrors `api/src/gym/member-service.js`'s own `PHONE_PATTERN`/`PHONE_MAX`
// (digits, spaces, '+', '-', '(' and ')', up to 30 characters) so every form
// that edits a phone (admin create/edit, the alumno's own profile) rejects an
// obviously invalid value before a round trip, without duplicating the regex
// three times over.
export const PHONE_MAX = 30;
const PHONE_PATTERN = /^[0-9 +()-]+$/;

/**
 * An empty/whitespace-only value is valid (it clears the phone, same
 * convention as `fitnessGoal`/DNI): only a non-empty value must match the
 * server's character set and length limit.
 */
export function isValidPhone(value) {
  const phone = typeof value === 'string' ? value.trim() : '';
  if (!phone) return true;
  return phone.length <= PHONE_MAX && PHONE_PATTERN.test(phone);
}
